import PasswordForm from 'app/components/Core/User/Passsword/Form'
import { useCurrentContactOrganization } from 'app/lib/hooks/useCurrent'
import Layout from 'app/pages/Authentication/Container/layout'
import { Routes } from 'app/routes/Routes'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const SetPassword: React.FC = () => {
  const navigate = useNavigate()
  const { role } = useCurrentContactOrganization()

  const onSuccess = () => {
    if (role === 'guest') {
      navigate(Routes.Authentication.collection().set_password_confirmation, { replace: true })
    } else {
      navigate(Routes.Overview.collection().index, { replace: true })
    }
  }

  return (
    <Layout>
      <PasswordForm props={{ onSuccess, visualAction: 'set_password', cancelable: false }} />
    </Layout>
  )
}

export default SetPassword
